/* Tab switching for the JS · Tabbed products section.

   Panels stay in the DOM and are toggled with a class, so switching is instant
   and nothing has to be re-fetched. Each section instance is wired separately —
   the page can carry more than one of these without them driving each other. */
(function () {
  'use strict';

  function wire(section) {
    var tabs = section.querySelectorAll('[data-jstab]');
    var panels = section.querySelectorAll('[data-jspanel]');
    if (!tabs.length) return;

    function show(idx) {
      Array.prototype.forEach.call(tabs, function (t) {
        var on = t.getAttribute('data-jstab') === idx;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      Array.prototype.forEach.call(panels, function (p) {
        p.classList.toggle('is-hidden', p.getAttribute('data-jspanel') !== idx);
      });
    }

    Array.prototype.forEach.call(tabs, function (t) {
      t.addEventListener('click', function () { show(t.getAttribute('data-jstab')); });
      /* left/right arrows walk the tablist, which is what a screen reader user
         expects from role="tablist" */
      t.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var list = Array.prototype.slice.call(tabs);
        var i = list.indexOf(t);
        var next = e.key === 'ArrowRight' ? (i + 1) % list.length
                                          : (i - 1 + list.length) % list.length;
        list[next].focus();
        show(list[next].getAttribute('data-jstab'));
        e.preventDefault();
      });
    });
  }

  function init() {
    document.querySelectorAll('.jstabs').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  /* the theme editor re-renders a section on edit, so re-wire the new copy */
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector ? e.target.querySelector('.jstabs') : null;
    if (s) wire(s);
  });
}());
